import React, {FC, useCallback} from 'react';

import { toast } from 'react-toastify';
import { useHistory } from 'react-router-dom';
// custom
import NavbarAdmin from '../../../../components/navbar/Navbar.admin';
import { useSelector } from 'react-redux';
import { IUserState } from '../../../../common/state/profile/user';
import { postEvent } from '../../../../common/async/AsyncCalls';
import { getParsedEPOCDate } from '../../../../common/helpers/CommonUtil';
import EventForm, { EventFormData } from '../../../../components/forms/events/Event.admin.form';


const EventCreateAdmin : FC = () => {
    const history = useHistory();    
    // states    
    const token: string = useSelector(({user} : {user: IUserState}) => user.token);
    // lifecycle
    const postNewEvent = useCallback(async(formData: EventFormData)=>{
        console.log('Create new event');
        const start_date: number = getParsedEPOCDate(formData.startDate as string)
        const end_date: number = getParsedEPOCDate(formData.endDate as string);
        // console.log('Start and End date in number: ', start_date, end_date);
        try {
            await postEvent(token, {
                title: formData.title,
                description: formData.description,
                active: formData.status === 'active' ? true : false,
                start_date,
                end_date,
                image_url: formData.url
            });
            toast("Event created successfully!");
            history.push({pathname: '/admin/events'});
        } catch (err) {
            console.log('Error posting new event: ', (err as Error).message);
        }
    },[token]);

    return <React.Fragment>
        <NavbarAdmin/>
        <div
            className="w-screen p-4 lg:p-16 min-h-screen bg-gray-200 dark:bg-gray-800
                text-gray-700  dark:text-teal-400 flex flex-col justify-start items-start">
            <h2 className="text-gray-700 dark:text-teal-400 text-2xl mb-2">Create New Event</h2>
            <p className="text-gray-700 dark:text-gray-300 dartext-base mb-4">
                Please fill out the below form to create a new Event. Please note that the fields marked with * are required.
            </p>
            <EventForm defaultFormData={{
                title: '',
                description: '',
                url: '',    
                status: 'inactive',
                startDate: null,
                endDate: null
            }}
                type = 'create' 
                onSubmit={postNewEvent}/>
        </div>
    </React.Fragment>
};

export default EventCreateAdmin;